import axios from 'axios';

const organizationService = {
	getOrganizationsDetails: async () => axios.get(`${process.env.OMZ_ZAPI}/admin/agents/organizations`, {
		headers: {
			Authorization: sessionStorage.getItem('omz_token')
		}
	}).then(result => result.data),

	fetchAccountToken: async organizationId => axios.post(`${process.env.OMZ_ZAPI}/admin/agents/change_organization`,
		{ organizationId },
		{
			headers: {
				Authorization: sessionStorage.getItem('omz_token')
			}
		}).then(result => result.data)
};

export default organizationService;
